import styled from 'styled-components';
import { NavLink as ReactNavLink } from 'react-router-dom';

export const Container = styled.nav`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 4px 0 8px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 999px;
    transition: background 0.2s ease;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: #cbd5e1;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

export const NavLink = styled(ReactNavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 4px 12px 0;
  padding: 14px 10px;
  border-radius: 12px;
  color: #475569;
  font-size: 0.78rem;
  font-weight: 500;
  text-align: center;
  line-height: 120%;
  letter-spacing: -0.01em;
  transition: all 0.2s ease;
  position: relative;

  svg {
    color: #64748b;
    transition: color 0.2s ease, transform 0.2s ease;
  }

  &:hover {
    background: #f1f5f9;
    color: #0f172a;
    text-decoration: none;

    svg {
      color: #0f172a;
      transform: translateY(-1px);
    }
  }

  &.active {
    background: #006633;
    color: #ffffff;
    box-shadow: 0 6px 16px rgba(0, 102, 51, 0.25);

    svg {
      color: #ffffff;
    }

    &::before {
      content: '';
      position: absolute;
      left: -12px;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 60%;
      background: #f38725;
      border-radius: 0 3px 3px 0;
    }

    &:hover {
      background: #006633;
      color: #ffffff;
    }
  }

  & + & {
    margin-top: 2px;
  }
`;

export const CovidIcon = styled.img`
  height: 24px;
  max-width: 100%;
  margin-bottom: 5px;
`;
